<template>
	<v-card>
		<v-card-title
			>Opties: {{ relationImport.originalFileName }}</v-card-title
		>
		<v-card-text>
			<v-radio-group
				v-model="hasHeader"
				label="Bevat onderstaande eerste regel van uw bestand de namen van de kolommen?"
			>
				<v-radio :value="true" :label="$localize('form.label.yes')" />
				<v-radio :value="false" :label="$localize('form.label.no')" />
			</v-radio-group>
			<table class="import-table">
				<thead>
					<tr class="preview-header">
						<th v-for="(column, index) in header" :key="index">
							{{ column }}
						</th>
					</tr>
				</thead>
			</table>
		</v-card-text>
		<v-card-actions>
			<v-btn @click="$emit('back')">{{
				$localize('form.button.back')
			}}</v-btn>
			<v-btn color="primary" @click="upload()">{{
				$localize('form.button.next')
			}}</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import sendCommand from '@/services/sendCommand'
import { getRelationImport, getRelationImportHeader } from '@/services/api'
import { isGuid } from '@/services/validation'
export default {
	props: {
		relationImportId: {
			validator: isGuid,
			required: true,
		},
	},
	data() {
		return {
			relationImport: {},
			header: [],
			hasHeader: true,
		}
	},
	async created() {
		const { result, ok } = await getRelationImport.call({
			args: { relationImportId: this.relationImportId },
		})
		if (ok) {
			this.relationImport = result
            this.hasHeader = this.relationImport.hasHeader
            await this.loadHeader();
		}
	},

	methods: {
		async loadHeader() {
			const { result, ok } = await getRelationImportHeader.call({
				args: { relationImportId: this.relationImportId },
			})
			if (ok) {
				this.header = result
			}
		},
		async upload() {
			const cmd = {
				relationImportId: this.relationImportId,
				hasHeader: this.hasHeader,
			}
			const result = await sendCommand('SetRelationImportOptions', cmd)
			if (result.success) {
				this.$emit('continue')
			}
		},
	},
}
</script>
